import React from 'react';
import PropTypes from 'prop-types';
import {useTheme} from '@material-ui/core/styles';
import {useMediaQuery, Grid, Typography} from '@material-ui/core';
import {Button} from 'gatsby-theme-material-ui';
import {Video} from 'components/atoms';
import {SectionHeader} from 'components/molecules';

const Hero = props => {
  const {className, ...rest} = props;

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid container justify="space-between" spacing={isMd ? 8 : 4}>
        <Grid item xs={12} md={6} data-aos="fade-up">
          <SectionHeader
            title={
              <span>
                Learn to{' '}
                <Typography component="span" variant="inherit" color="primary">
                  code,
                </Typography>
                <br />
                <span>Build your future.</span>
              </span>
            }
            subtitle="Computer Science is the world's first superpower. It enables people of all backgrounds to earn a six figure salary while building the world of tomorrow."
            ctaGroup={[
              <Button
                variant="contained"
                color="primary"
                size="large"
                to={process.env.GATSBY_START_LEARNING_CTA_LINK}
              >
                Start Learning Intro CS
              </Button>,
              <Button variant="contained" color="primary" size="large" to="/tutorials/">
                Tutorials
              </Button>,
            ]}
            align={isMd ? 'left' : 'center'}
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid item container justify="center" alignItems="center" xs={12} md={6} data-aos="fade-up">
          <Video videoId="ilgO5TdRf_M" alt="The Power of Programming" preview />
        </Grid>
      </Grid>
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
